import { isEmpty, values } from 'underscore';

import {
  getWebsiteSourceDataByKey,
  WEBSITE_SOURCE_DATA_KEY_MAPPING,
} from '@bingads-webui-campaign-react/smart-component-util';
import { getErrors } from './errors';

export function smartVideoValidator({
  siteConfig,
  i18n,
}) {
  const componentConfig =
    getWebsiteSourceDataByKey(siteConfig, WEBSITE_SOURCE_DATA_KEY_MAPPING.EmbeddedVideos);
  // Now we only support 1 video.
  const videoConfig = (!isEmpty(componentConfig) && componentConfig[0]) || {};

  const errors = getErrors(videoConfig, i18n);

  // For video embed section, url/description error don't block user to publish smart page.
  // so isValid will always be true, and we store errors in warnings.
  return {
    isValid: true,
    isWarning: !isEmpty(errors),
    warnings: values(errors),
  };
}
